module.exports = __webpack_public_path__ + "static/media/Profile.91b12b74.svg";